import { useMemo, useState } from "react";
import { API_SPECS } from "../constants/apiSpecs";

export default function Sidebar({
  apiSpec,
  selectedApi,
  onApiChange,
  activeSection,
  setActiveSection,
}) {
  const [expandedApis, setExpandedApis] = useState({ [selectedApi.id]: true });

  const getEndpointsForApi = (apiId) => {
    if (selectedApi.id !== apiId || !apiSpec?.paths) return [];
    return Object.keys(apiSpec.paths);
  };

  const handleEndpointClick = (sectionId, event) => {
    event.stopPropagation();
    setActiveSection(sectionId);
  };

  const toggleApi = (apiId) => {
    setExpandedApis((prev) => ({
      ...prev,
      [apiId]: !prev[apiId],
    }));

    const api = API_SPECS.find((a) => a.id === apiId);
    window.location.hash = `#${apiId}`;
    if (api) {
      onApiChange(api);
      setActiveSection("overview");
    }
  };

  return (
    <div className="sidebar">
      <div className="logo">
        <img
          src="https://internal.letsflo.io/assets/images/logo-dark.png"
          alt="Lets Flo"
        />
      </div>

      <div className="nav-section">
        <div className="nav-title">API Documentation</div>

        {API_SPECS.map((api) => {
          const isSelected = selectedApi.id === api.id;
          const isExpanded = expandedApis[api.id];
          const endpoints = getEndpointsForApi(api.id);

          return (
            <div key={api.id}>
              <div
                className={`nav-item ${isSelected ? "active" : ""}`}
                onClick={() => toggleApi(api.id)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                }}
              >
                <span>{api.name}</span>
                {isSelected && endpoints.length > 0 && (
                  <span
                    style={{
                      fontSize: "12px",
                      transition: "transform 0.2s ease",
                      transform: isExpanded ? "rotate(90deg)" : "rotate(0deg)",
                    }}
                  >
                    ▶
                  </span>
                )}
              </div>

              {isSelected && isExpanded && (
                <>
                  <div
                    className={`nav-subitem ${
                      activeSection === "overview" ? "active" : ""
                    }`}
                    onClick={(e) => handleEndpointClick("overview", e)}
                  >
                    📖 Overview
                  </div>
                  <div
                    className={`nav-subitem ${
                      activeSection === "authentication" ? "active" : ""
                    }`}
                    onClick={(e) => handleEndpointClick("authentication", e)}
                  >
                    🔐 Authentication
                  </div>

                  {endpoints.length > 0 && (
                    <>
                      <div
                        style={{
                          padding: "12px 16px 8px 32px",
                          fontSize: "11px",
                          fontWeight: 700,
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                          color: "rgba(255, 255, 255, 0.4)",
                        }}
                      >
                        Endpoints
                      </div>
                      {endpoints.map((path) => {
                        const methods = Object.keys(apiSpec.paths[path]);
                        return (
                          <div key={path}>
                            {methods.map((method) => {
                              const sectionId = `${method}-${path}`;
                              return (
                                <div
                                  key={sectionId}
                                  className={`nav-subitem ${
                                    activeSection === sectionId ? "active" : ""
                                  }`}
                                  onClick={(e) => handleEndpointClick(sectionId, e)}
                                  style={{ paddingLeft: "32px" }}
                                >
                                  <span
                                    style={{
                                      textTransform: "uppercase",
                                      fontWeight: 700,
                                      marginRight: "8px",
                                      fontSize: "11px",
                                    }}
                                  >
                                    {method}
                                  </span>
                                  <span style={{ fontSize: "12px" }}>{path}</span>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </>
                  )}

                  <div
                    className={`nav-subitem ${
                      activeSection === "schemas" ? "active" : ""
                    }`}
                    onClick={(e) => handleEndpointClick("schemas", e)}
                  >
                    📋 Schemas
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
